import { ConfirmDialogConfig } from '@agent-ds/shared/components/confirm-dialog/confirm-dialog-config';
import { ConfirmDialogComponent } from '@agent-ds/shared/components/confirm-dialog/confirm-dialog.component';
import { Tab } from '@agent-ds/shared/models';
import { DialogService, StudentApiService } from '@agent-ds/shared/services';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, forwardRef, Input } from '@angular/core';

@Component({
  selector: 'ag-student-memo-tab',
  templateUrl: './student-memo-tab.component.html',
  styleUrls: ['./student-memo-tab.component.scss'],
  providers: [{ provide: Tab, useExisting: forwardRef(() => StudentMemoTabComponent) }],
})
export class StudentMemoTabComponent extends Tab {
  @Input() studentId: number;

  constructor(public readonly studentApiService: StudentApiService, private readonly dialogService: DialogService) {
    super();
  }

  errorGetMemosCallback(error: HttpErrorResponse) {
    if (!error.status) {
      // ネットワークに繋がらなかったときはエラーを通知する
      this.showErrorDialog();
      this.studentApiService.notifyConnectionErrorEvent.emit();
    } else {
      // その他のエラーは共通部分でハンドリングされているのでここではハンドリングしない
    }
  }

  private showErrorDialog() {
    // ダイアログによる通知
    const dialogConfig: ConfirmDialogConfig = ConfirmDialogConfig.createStudentApiErrorDialogConfig([
      '状況メモの取得中に通信エラーが発生しました。',
      '画面上部右側の「求職者の全情報を再取得する」ボタンを押して再度取得してください。',
    ]);
    this.dialogService.open(ConfirmDialogComponent, dialogConfig);
  }
}
